module.exports = __webpack_public_path__ + "03_short_gold.fea8c8ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_short_gold.png
// module id = ViGG
// module chunks = 0